import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Icon,
  Select,
  Message,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import { CANCELATION_REASONS } from '../../constants';

class PendingGuaranteeReject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guaranteePurchaseId: null,
      rejectionReason: null,
      ineligibleForRepurchase: false,
      skipApplyingCredit: false,
      errors: {},
    };
  }

  componentDidMount() {
    const { pendingGuarantee } = this.props;
    const { guaranteePurchaseId } = pendingGuarantee;

    this.setState({ guaranteePurchaseId });
  }

  render() {
    const {
      pendingGuarantee,
      isPendingRejectModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      errors,
      rejectionReason,
      ineligibleForRepurchase,
      skipApplyingCredit,
    } = this.state;

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
    };

    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const validationRules = {
      rejectionReason: 'required',
    };

    const submitForm = () => {
      const {
        guaranteePurchaseId,
      } = this.state;

      const validation = new Validator(this.state, validationRules);

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        guaranteePurchaseId,
        rejection: {
          rejectionReason,
          ineligibleForRepurchase,
          skipApplyingCredit,
        },
      });
      this.setState({ errors: {} });
      return true;
    };

    const {
      vehicleInformation: { vin },
    } = pendingGuarantee;

    return (
      <Modal
        open={isPendingRejectModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Reject Pending Purchase for VIN {vin}</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form widths='equal'>
              <Form.Field required error={!isEmpty(errors.rejectionReason)}>
                <label htmlFor='rejectionReason'>Reason</label>
                <Select
                  id='rejectionReason'
                  placeholder='Select rejection reason'
                  options={CANCELATION_REASONS}
                  closeOnBlur
                  value={rejectionReason}
                  onChange={onSelectHandler('rejectionReason')}
                />
                {errors.rejectionReason && (
                  <span className='error-text'>{errors.rejectionReason}</span>
                )}
              </Form.Field>
              <Form.Group widths='equal'>
                <Form.Field>
                  <Checkbox
                    label='Ineligible for repurchase'
                    checked={ineligibleForRepurchase}
                    onChange={onCheckboxHandler('ineligibleForRepurchase')}
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    label='Skip Applying Credit'
                    checked={skipApplyingCredit}
                    onChange={onCheckboxHandler('skipApplyingCredit')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting && (
            <Button color='green' onClick={submitForm} inverted>
              <Icon name='checkmark' /> Submit
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

PendingGuaranteeReject.propTypes = {
  pendingGuarantee: PropTypes.shape({
    guaranteePurchaseId: PropTypes.string,
    vehicleInformation: PropTypes.shape({
      vin: PropTypes.string,
    }),
  }).isRequired,
  isPendingRejectModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
};

export default PendingGuaranteeReject;
